import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Vehicle } from '../../vehicles/model/vehicle';
import { RestService } from '../../shared/service/rest.service';
import { flatMap, sortBy } from 'lodash';
import { ResponseWrapper } from 'src/app/shared/model/rest-response';
import { ResourceNumericVersionIdentifier } from 'src/app/common/model/resource-id-version-identifier';


@Injectable()
export class VehicleService extends RestService {
  fetchVehicles(): Observable<Vehicle[]> {
    return this.postAndExtract<Vehicle>(Vehicle, 'api/vehicles/fetch', {}).pipe(
      map(vehicles => sortBy(vehicles, vehicle => vehicle.sideNumber))
    );
  }

  fetchLines(): Observable<string[]> {
    return this.doPost<ResponseWrapper<Record<string, any>>>('api/fetch/lines')
      .pipe(map(response => flatMap(response.response.data, line => line?.line)));
  }

  assignDepot(vehicleId: number, depotId: ResourceNumericVersionIdentifier | null): Observable<void> {
    const params = depotId != null ? { depotId: depotId.toString() } : {};
    return this.doPost(`api/vehicle/${vehicleId}/depot`, null, { params });
  };

}
